import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var UnsupportedError = /*#__PURE__*/function (_Error) {
  function UnsupportedError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Unsupported';
    _classCallCheck(this, UnsupportedError);
    return _callSuper(this, UnsupportedError, [message]);
  }
  _inherits(UnsupportedError, _Error);
  return _createClass(UnsupportedError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Creates a new UnsupportedError
 * @param message
 */
function createUnsupportedError(message) {
  return new UnsupportedError(message);
}
export { UnsupportedError, createUnsupportedError };